import ObjectHash from 'object-hash'

export const state = () => ({
	dashboardStat: {},
	cache_key_dashboard: [],
	ttl_dashboard: [],
	cache_duration_dashboard: 10800000, // 3 heures
})

function isInCacheDashboard(state, statName, companyId, params = {}, evolution = false) {
	const statKey = evolution ? statName + '_evolution' : statName
	if (!state.ttl_dashboard[statKey] || state.ttl_dashboard[statKey] < Date.now()) {
		return false
	}

	const cacheKey = buildCacheKeyDashboard(statKey, companyId, params)

	return state.cache_key_dashboard.find((e) => e === cacheKey)
}

function buildCacheKeyDashboard(statKey, companyId, params) {
	return `company:${companyId}:dashboard::params:${ObjectHash(params)}:${statKey}`
}

export const actions = {
	async getDashboardStat({ state, commit }, { companyId, statName, params, evolution }) {
		const statKey = evolution ? statName + '_evolution' : statName

		if (isInCacheDashboard(state, statName, companyId, params, evolution)) {
			return state.dashboardStat[statKey]
		}
		return await useNuxtApp()
			.$api(`/api/company/${companyId}/challenge-creators/stats-${statName}/`, { params })
			.then((res) => {
				commit('clearCacheDashboardStat', statKey)
				commit('setDashboardCache', { res, statName, params, companyId, evolution })
				return res
			})
			.catch((err) => {
				commit('clearCacheDashboardStat', statKey)
				throw err
			})
	},

	async getCreatorsContents(_, { companyId, params, limit, customURL = null }) {
		let url = `/api/company/${companyId}/challenge-creators/?${params}&limit=${limit}`
		if (customURL) {
			url = customURL
		}
		return await useNuxtApp()
			.$api(url)
			.then((res) => {
				return res
			})
	},
}

export const mutations = {
	setDashboardCache(state, { res, statName, params, companyId, evolution = false }) {
		const statKey = evolution ? statName + '_evolution' : statName
		const cacheKey = buildCacheKeyDashboard(statKey, companyId, params)

		state.dashboardStat = { ...state.dashboardStat, [statKey]: res }
		state.ttl_dashboard = {
			...state.ttl_dashboard,
			[statKey]: Date.now() + state.cache_duration_dashboard,
		}
		state.cache_key_dashboard.push(cacheKey)
	},

	clearCacheDashboardStat(state, statKey) {
		state.dashboardStat = Object.fromEntries(
			Object.entries(state.dashboardStat).filter(([key]) => key !== statKey),
		)

		state.ttl_dashboard = Object.fromEntries(
			Object.entries(state.ttl_dashboard).filter(([key]) => key !== statKey),
		)
		state.cache_key_dashboard = state.cache_key_dashboard.filter(
			(val) => !val.endsWith(statKey),
		)
	},
}
